import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { type FileShareInput, filesApi } from '../api/files.api'
import { filesKeys } from './query-keys'

export const useFileShares = (fileId: string) =>
	useQuery({
		queryKey: filesKeys.shares(fileId),
		queryFn: () => filesApi.listShares(fileId),
		enabled: !!fileId,
	})

export const useCreateFileShare = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: ({ fileId, data }: { fileId: string; data: FileShareInput }) => filesApi.createShare(fileId, data),
		onSuccess: (_data, variables) => void qc.invalidateQueries({ queryKey: filesKeys.shares(variables.fileId) }),
	})
}

export const useRevokeFileShare = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: ({ fileId, shareId }: { fileId: string; shareId: string }) => filesApi.revokeShare(fileId, shareId),
		onSuccess: (_data, variables) => void qc.invalidateQueries({ queryKey: filesKeys.shares(variables.fileId) }),
	})
}
